import {useEffect, useState} from 'react';
import * as store from '@/store/index';
import {importAsyncComponent} from '@/utils/loadable';

export interface IProps {
    showDocStatDialog?: {show: boolean, wordNumber?: number};
    // @todo 后续优化
    getDocLength: () => number;
    // onCancel: () => void;
}

const Dialog = importAsyncComponent(() => import('./Dialog'));
const DocStatsDialog: React.FC<IProps> = ({showDocStatDialog, getDocLength}) => {
    const {show = false, wordNumber} = showDocStatDialog || {};

    if (show) {
        return (
            <Dialog getDocLength={getDocLength} wordNumber={wordNumber} />
        );
    }
    return null;
};


export default store.connect([
    store.KEYS.SHOW_DOC_STAT_DIALOG,
])(DocStatsDialog);
